import { render } from "./NewBusinessRuleActionSendXtraReport.vue?vue&type=template&id=f927884c"
import script from "./NewBusinessRuleActionSendXtraReport.vue?vue&type=script&lang=js"
export * from "./NewBusinessRuleActionSendXtraReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__